import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(ITile) {
    (function(ISduiProductTile) {
        (function(ISduiProductTileBrandInfo) {
            ISduiProductTileBrandInfo.build = function(partial) {
                return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
            };
        })(ISduiProductTile.ISduiProductTileBrandInfo || (ISduiProductTile.ISduiProductTileBrandInfo = {}));
        ISduiProductTile.build = function(partial) {
            return _object_spread({
                badges: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ITile.ISduiProductTile || (ITile.ISduiProductTile = {}));
    (function(ProductTileVariant) {
        ProductTileVariant["PRODUCT_TILE_VARIANT_UNKNOWN"] = "PRODUCT_TILE_VARIANT_UNKNOWN";
        /**
     * Tile with square product image and product name, App only
     * @deprecated
     */ ProductTileVariant["DEFAULT_PRODUCT_TILE"] = "DEFAULT_PRODUCT_TILE";
        /**
     * Web + App
     */ ProductTileVariant["IMAGE_ONLY_TILE"] = "IMAGE_ONLY_TILE";
        /**
     * Web + App - image only tile with price in bottom left corner
     * @deprecated
     */ ProductTileVariant["IMAGE_ONLY_TILE_WITH_PRICE"] = "IMAGE_ONLY_TILE_WITH_PRICE";
        /**
     * Web + App - all tiles are from the same brand
     */ ProductTileVariant["EVALUATE_TILE"] = "EVALUATE_TILE";
        /**
     * Web + App - tiles are from many brands
     */ ProductTileVariant["DISCOVERY_TILE"] = "DISCOVERY_TILE";
    })(ITile.ProductTileVariant || (ITile.ProductTileVariant = {}));
    (function(ISduiBrandTile) {
        ISduiBrandTile.build = function(partial) {
            return _object_spread({
                badges: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ITile.ISduiBrandTile || (ITile.ISduiBrandTile = {}));
    (function(SduiBrandTileVariant) {
        SduiBrandTileVariant["SDUI_BRAND_TILE_VARIANT_UNKNOWN"] = "SDUI_BRAND_TILE_VARIANT_UNKNOWN";
        /**
     * Tile designed for general use across carousels and grids. Supported by both web and apps.
     */ SduiBrandTileVariant["DEFAULT_BRAND_TILE"] = "DEFAULT_BRAND_TILE";
        /**
     * Tile designed for a single-column grid form factor. Intended for use for category brand-first pages for apps.
     */ SduiBrandTileVariant["LARGE_BRAND_TILE"] = "LARGE_BRAND_TILE";
    })(ITile.SduiBrandTileVariant || (ITile.SduiBrandTileVariant = {}));
    (function(ITileStyle) {
        ITileStyle.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ITile.ITileStyle || (ITile.ITileStyle = {}));
    ITile.build = function(partial) {
        return _object_spread({
            on_view: [],
            on_click: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(ITile || (ITile = {}));
export var ITile;
